import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-celeste/15 bg-abyss/40 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxl9jo5ok8b">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop6q1o1h1kv">I {totalBonuses} <span className="text-gold" data-id="element-21" data-mp="15pw454aaiuzh">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-celeste/20 bg-ink/55 shadow-lg shadow-black/30 backdrop-blur-md" data-id="element-22" data-mp="15njf67647kcx">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-celeste/10 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzy9c5huv71b" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-celeste/40 bg-abyss/60 text-celeste" data-id="element-24" data-mp="2jj7goc2bh64y">
                  <Icon className="h-5 w-5 drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-25" data-mp="1qt8nc4h3amuh" />
                </span>
                <div data-id="element-26" data-mp="1vrik2jigpvi7">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-27" data-mp="1vt3gkeoc7oip">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-28" data-mp="20q3iqei2g74j">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-mist" data-id="element-29" data-mp="25oewh0bhf1s1">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-ink/70 px-6 py-6 text-center shadow-lg shadow-black/40 backdrop-blur-md sm:flex-row sm:text-left" data-id="element-30" data-mp="3h4bst9lngnza">
          <div data-id="element-31" data-mp="1c3sr5lc782zh">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-mist" data-id="element-32" data-mp="1c6eu17o59ubd">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-mist line-through decoration-gold decoration-2" data-id="element-33" data-mp="1m2rnc4fs265l">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="yajglhcilbfd">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-mist" data-id="element-35" data-mp="tem3rl0gmn7c">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-gold" data-id="element-36" data-mp="176990acdr629">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="12dpmgnvpt0lb" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}